import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';
import { Products } from 'src/app/_models/products';
import { ProblemsService } from 'src/app/_services/problems.service';
import { ImpactsService } from 'src/app/_services/impacts.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TicketsService } from 'src/app/_services/tickets.service';
import { User } from 'src/app/_models';
import { NotificationService } from 'src/app/_services/notification.service';

import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UploadService } from 'src/app/_services/upload.service';

import { Location } from '@angular/common';

@Component({
  selector: 'app-create-tickets',
  templateUrl: './create-tickets.component.html',
  styleUrls: ['./create-tickets.component.css'],
})
export class CreateTicketsComponent implements OnInit {
  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;
  files = [];

  loading = false;
  error = '';
  products: any[];
  problems: any[];
  impacts: any[];
  ticketForm: FormGroup;
  returnUrl: string = '/my-tickets';
  submitted: boolean = false;
  selectedProductId: string;
  selectedProblemId: string;
  selectedImpactId: string;
  ticketId: string;
  cUser: User;
  isMaxFileCountReached: boolean = false;
  allowedFileExtensions: any;
  isCSPUser: boolean = false;
  isAdminUser: boolean = false;

  constructor(
    private productservice: ProductsService,
    private problemservice: ProblemsService,
    private impactservice: ImpactsService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
    private uploadService: UploadService,
    private ticketsService: TicketsService,
    private location: Location
  ) {
    this.cUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit(): void {
    this.ticketForm = this.formBuilder.group({
      product: ['', Validators.required],
      problem: ['', Validators.required],
      impact: ['', Validators.required],
      contact: [
        '',
        [
          Validators.required,
          Validators.maxLength,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        ],
      ],
      email: ['', [Validators.required, Validators.email]],
      descripition: ['', Validators.required],
    });

    // contact: ['', Validators.required, Validators.maxLength(10), Validators.pattern("^[6-9]d{9}$")],
    // email: ['', Validators.required,Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")],

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.getProductList();
    this.allowedFileExtensions = ['JPEG', 'JPG', 'PNG', 'GIF', 'TIFF', 'PSD'];

    this.isCSPUser = this.cUser.roles == 'CSP' ? true : false;
    this.isAdminUser = this.cUser.roles == 'Admin' ? true : false;
  }

  /* Handle form errors in Angular */
  public hasError = (controlName: string, errorName: string) => {
    return this.ticketForm.controls[controlName].hasError(errorName);
  };

  // convenience getter for easy access to form fields
  get f() {
    return this.ticketForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.ticketForm.invalid) {
      return;
    }

    this.loading = true;

    const param = {
      ProductId: this.f.product.value,
      ProblemId: this.f.problem.value,
      ImpactID: this.f.impact.value,
      TicketStatusID: 1,
      Contact: this.f.contact.value.toString(),
      CC_EmailId: this.f.email.value,
      Description: this.f.descripition.value,
      Assinged: 1,
      CreatedBy: this.cUser.userId,
      UserId: this.cUser.userId,
      UserName: this.cUser.name,
    };

    this.ticketsService.createTicket(param).subscribe(
      (data) => {
        if (data) {
          this.ticketId = data.toString();
          this.uploadFiles();
          this.loading = false;
          if (this.isAdminUser || this.isCSPUser) {
            this.router.navigate(['/all-tickets']);
          } else {
            this.router.navigate(['/my-tickets']);
          }
        }
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  getProductList() {
    this.productservice.getProductList().subscribe(
      (res) => {
        this.products = <any[]>res;
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  onProductSelection() {
    this.getProblems(this.selectedProductId);
  }

  getProblems(productId: string) {
    this.problemservice.getProblemsByProductId(productId).subscribe(
      (res) => {
        this.problems = <any[]>res;
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  onProblemSelection() {
    this.getImpacts(this.selectedProductId, this.selectedProblemId);
  }

  getImpacts(selectedProductId: string, selectedProblemId: string) {
    this.impactservice
      .getImpactList(selectedProductId, selectedProblemId)
      .subscribe(
        (res) => {
          this.impacts = <any[]>res;
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
  }

  onClose() {
    this.location.back();
    // this.router.navigate(['/my-tickets']);
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('files', file.data);
    formData.append('ticketId', this.ticketId);
    formData.append('createdBy', this.cUser.userId);
    file.inProgress = true;
    this.uploadService
      .upload(formData)
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              file.progress = Math.round((event.loaded * 100) / event.total);
              break;
            case HttpEventType.Response:
              return event;
          }
        }),
        catchError((error: HttpErrorResponse) => {
          file.inProgress = false;
          return of(`${file.data.name} upload failed.`);
        })
      )
      .subscribe((event: any) => {
        if (typeof event === 'object') {
        }
      });
  }

  private uploadFiles() {
    this.fileUpload.nativeElement.value = '';
    this.files.forEach((file) => {
      this.uploadFile(file);
    });
  }

  onUploadClick() {
    const fileUpload = this.fileUpload.nativeElement;
    fileUpload.onchange = () => {
      if (fileUpload.files.length >= 5) {
        this.notifyService.showError(
          'Maximum 5 attachment is allowed!',
          'CGP Portal'
        );
      }
      if (this.files.length > 4) {
        this.notifyService.showError(
          'Maximum 5 attachment is allowed!',
          'CGP Portal'
        );
        this.isMaxFileCountReached = true;
        return false;
      }
      if (fileUpload.files.length == 5 || this.files.length == 5) {
        this.isMaxFileCountReached = true;
      }

      for (let index = 0; index < 5; index++) {
        const file = fileUpload.files[index];
        let extension = file.name.split('.')[1].toUpperCase();
        if (!this.allowedFileExtensions.includes(extension)) {
          this.notifyService.showWarning(
            'Please upload only image file.',
            'CGP Portal'
          );
          return;
        }
        this.files.push({ data: file, inProgress: false, progress: 0 });
      }
    };
    fileUpload.click();
  }

  RemoveAttachedFile(index: number) {
    this.files.splice(index, 1);
    if (this.files.length <= 5) {
      this.isMaxFileCountReached = false;
    }
  }
}
